import { render, staticRenderFns } from "./NewOdontogramaCrianca.vue?vue&type=template&id=7648e6d4&scoped=true&"
import script from "./NewOdontogramaCrianca.vue?vue&type=script&lang=js&"
export * from "./NewOdontogramaCrianca.vue?vue&type=script&lang=js&"
import style0 from "./NewOdontogramaCrianca.vue?vue&type=style&index=0&id=7648e6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648e6d4",
  null
  
)

export default component.exports